import { render, staticRenderFns } from "./policyWft2.vue?vue&type=template&id=64c20024"
import script from "./policyWft2.vue?vue&type=script&lang=js"
export * from "./policyWft2.vue?vue&type=script&lang=js"
import style0 from "./policyWft2.vue?vue&type=style&index=0&id=64c20024&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports